export default {
  女装: "মহিলাদের পোশাক",
  男装: "পুরুষদের",
  手机和小工具: "মোবাইল ফোন এবং ছোট সরঞ্জাম",
  居家生活: "হোম লাইফ",
  电脑及周边设备: "কম্পিউটার এবং পেরিফেরিয়াল সরঞ্জাম",
  美容及个人护理: "সৌন্দর্য এবং ব্যক্তিগত যত্ন",
  家用电器: "অ্যাপ্লায়েন্স",
  健康与保健: "স্বাস্থ্য ও স্বাস্থ্যসেবা",
  食品和饮料: "খাবার এবং পানীয়",
  玩具_儿童和婴儿: "খেলনা, শিশু এবং শিশুদের",
  童装时尚: "বাচ্চাদের পোশাক ফ্যাশন",
  视频游戏: "ভিডিও গেমস",
  运动与户外: "অনুশীলন এবং বহিরঙ্গন",
  爱好与书籍: "শখ এবং বই",
  相机和无人机: "ক্যামেরা এবং ড্রোন",
  宠物食品及用品: "পোষা খাবার এবং সরবরাহ",
  女士包袋: "মহিলা ব্যাগ",
  男士包袋: "পুরুষদের ব্যাগ",
  珠宝及配饰: "গহনা এবং আনুষাঙ্গিক",
  手表: "দেখুন",
  女鞋: "মহিলাদের জুতা",
  男装鞋: "পুরুষদের জুতা",
  汽车: "গাড়ি",
  我附近的ShopeePay: "আমার কাছাকাছি শোপাইপে",
  餐饮_旅行和服务: "ক্যাটারিং, ভ্রমণ এবং পরিষেবা",
  旅行及行李: "ভ্রমণ এবং লাগেজ",
  各种各样的: "বিভিন্ন",
  我是来买什么的: "আমি এখানে কিনতে এসেছি",
  对不起_找不到_相关的商品:
    "দুঃখিত, আপনি [{0}] সম্পর্কিত পণ্যগুলি খুঁজে পাচ্ছেন না",
  类别: "বিভাগ",
  产品: "পণ্য",
  店铺: "দোকান",
  首页: "প্রথম পৃষ্ঠা",
  限时秒杀: "সীমিত সময় স্পাইক",
  博客: "ব্লগ",
  所有品牌: "সমস্ত ব্র্যান্ড",
  所有类别: "সমস্ত বিভাগ",
  我的购物车: "আমার শপিং কার্ট",
  发货信息: "বিতরণ তথ্য",
  交货信息: "বিতরণ তথ্য",
  付款: "অর্থ প্রদান",
  确认: "নিশ্চিত করুন",
  您的购物车是空的: "আপনার শপিং কার্ট খালি",
  价格: "দাম",
  税: "কর",
  数量: "পরিমাণ",
  总计: "মোট",
  移除: "সরান",
  返回商店: "দোকানে ফিরে আসুন",
  继续发货: "বিতরণ চালিয়ে যান",
  筛选: "ফিল্টার",
  价格范围: "দাম",
  排序方式: "সাজান",
  最新: "আপ টু ডেট",
  最旧: "পুরানো",
  价格从低到高: "কম থেকে উচ্চ পর্যন্ত দাম",
  价格从高到低: "দাম উচ্চ থেকে কম পর্যন্ত",
  选择交货类型: "বিতরণ প্রকার নির্বাচন করুন",
  送货上门: "বিতরণ",
  继续付款: "প্রদান চালিয়ে যান",
  任何其他信息: "অন্য কোন তথ্য",
  或者: "বা",
  您的钱包余额: "আপনার মানিব্যাগ ভারসাম্য",
  余额不足: "অপর্যাপ্ত ভারসাম্য",
  支付: "পে",
  我同意: "আমি সম্মত",
  条款和条件: "শর্তাদি এবং শর্তাদি",
  退货政策: "রিটার্ন নীতি",
  隐私政策: "গোপনীয়তা",
  概括: "যোগফল",
  项目: "প্রকল্প",
  全部的: "সমস্ত -আলা",
  小计: "স্কেচ",
  总运费: "মোট মালবাহী",
  有优惠码吗_在这里输入: "ছাড় কোড আছে? এখানে প্রবেশ করুন",
  申请: "প্রয়োগ করুন",
  编辑: "সম্পাদনা",
  删除: "মুছুন",
  添加新地址: "নতুন ঠিকানা যুক্ত করুন",
  继续交货信息: "বিতরণ তথ্য চালিয়ে যান",
  选择一个地址: "একটি ঠিকানা নির্বাচন করুন",
  购买历史: "ইতিহাস কিনুন",
  下载: "ডাউনলোড",
  已发送退款请求: "ফেরত অনুরোধ একটি ফেরত অনুরোধ প্রেরণ",
  对比: "বিপরীতে",
  对话: "কথোপকথন",
  我的钱包: "আমার মানিব্যাগ",
  工单: "ওয়ার্ক অর্ডার",
  管理个人资料: "ব্যক্তিগত তথ্য পরিচালনা করুন",
  登出: "সাইন আউট",
  重置对比列表: "তুলনা তালিকা পুনরায় সেট করুন",
  您的对比列表为空: "আপনার তুলনা তালিকা খালি",
  在您的购物车中: "আপনার শপিং কার্টে",
  在您的愿望清单中: "আপনার ইচ্ছার তালিকায়",
  在您的预定列表中: "আপনার নির্ধারিত তালিকায়",
  下载您的产品: "আপনার পণ্য ডাউনলোড করুন",
  选项: "বিকল্প",
  什么都没找到: "আমি কিছুই পাইনি",
  特色产品: "বিশেষ পণ্য",
  最畅销: "সেরা -বিক্রয়",
  前_名: "পূর্ববর্তী {0} নাম",
  查看更多: "আরও দেখুন",
  查看所有类别: "সমস্ত বিভাগ দেখুন",
  十大品牌: "শীর্ষ দশ ব্র্যান্ড",
  查看所有品牌: "সমস্ত ব্র্যান্ড দেখুন",
  登录: "লগ ইন",
  手机号码: "ফোন নম্বর",
  密码: "পাসওয়ার্ড",
  密码长度为6到16个字符: "পাসওয়ার্ডের দৈর্ঘ্য 6 থেকে 16 টি অক্ষর",
  验证码: "যাচাইকরণ কোড",
  登录中: "লগ ইন",
  游客登录: "পর্যটন লগইন",
  注册您的商店: "আপনার স্টোর নিবন্ধন করুন",
  现在申请: "এখনই আবেদন করুন",
  成为商家: "বণিক হয়ে উঠুন",
  现在注册: "এখনই নিবন্ধন করুন",
  登录成功: "সফল লগইন",
  通知: "অবহিত",
  未找到通知: "কোন বিজ্ঞপ্তি",
  评论: "মন্তব্য",
  估计运输时间: "আনুমানিক পরিবহণের সময়",
  天: "আকাশ",
  所售: "বিক্রয়",
  给商家留言: "বণিককে একটি বার্তা দিন",
  规格: "স্পেসিফিকেশন",
  库存: "স্টক",
  总价: "সাধারণ মূল্য",
  添加到购物车: "কার্টে যোগ করুন",
  立即购买: "এখনই এটি কিনুন",
  缺货: "স্টক বাইরে",
  添加到愿望清单: "ইচ্ছার তালিকায় যুক্ত করুন",
  加入对比列表: "তুলনা তালিকা যুক্ত করুন",
  退款: "ফেরত",
  查看条款: "ধারা দেখুন",
  分享: "ভাগ",
  描述: "বর্ণনা",
  相关产品: "সম্পর্কিত পণ্য",
  没有人问过商家: "কেউ বণিককে জিজ্ঞাসা করেনি",
  该产品暂无评论: "এই পণ্য সম্পর্কে কোন মন্তব্য নেই",
  客户评论: "গ্রাহক মন্তব্য",
  访问商店: "স্টোর দেখুন",
  畅销产品: "সেরা -বিক্রয় পণ্য",
  日期: "তারিখ",
  订单编号: "অর্ডার নম্বর",
  总额: "একক যোগ",
  状态: "রাষ্ট্র",
  愿望清单: "ইচ্ছা তালিকা",
  还没有添加任何东西: "এখনও কিছু যোগ করেনি",
  注册: "নিবন্ধন করুন",
  邀请码: "আমন্ত্রণ কোড",
  请输入邀请码: "আমন্ত্রণ কোড লিখুন দয়া করে",
  用户名: "ব্যবহারকারীর নাম",
  请输入用户名: "দয়া করে ব্যবহারকারীর নাম লিখুন",
  用户名长度为6_14个字符: "ব্যবহারকারীর নাম দৈর্ঘ্য 6-14 অক্ষর",
  昵称: "নিক নাম",
  请输入手机号码: "দয়া করে মোবাইল ফোন নম্বর লিখুন",
  手机号码格式错误: "মোবাইল ফোন নম্বর ফর্ম্যাট ত্রুটি",
  密码长度为6_16个字符: "পাসওয়ার্ডের দৈর্ঘ্য 6-16 অক্ষর",
  确认密码: "পাসওয়ার্ড নিশ্চিত করুন",
  请输入确认密码: "নিশ্চিতকরণ পাসওয়ার্ড লিখুন দয়া করে",
  提款密码: "প্রত্যাহার পাসওয়ার্ড",
  请输入提款密码: "প্রত্যাহারের পাসওয়ার্ড লিখুন দয়া করে",
  提款密码长度为4_16个字符: "প্রত্যাহারের পাসওয়ার্ডের দৈর্ঘ্য 4-16 অক্ষর",
  请输入验证码: "যাচাইকরণ কোড লিখুন দয়া করে",
  在_s后发送: "{0} s পরে প্রেরণ করুন",
  发送验证码: "যাচাইকরণ কোড প্রেরণ করুন",
  注册即表示您同意我们的条款和条件:
    "নিবন্ধকরণের অর্থ আপনি আমাদের শর্তাদি এবং শর্তগুলির সাথে একমত হন।",
  创建账号: "একটি অ্যাকাউন্ট তৈরি করুন",
  验证码发送成功: "যাচাইকরণ কোড সফলভাবে প্রেরণ করে",
  确认密码不一致: "পাসওয়ার্ডটি বেমানান কিনা তা নিশ্চিত করুন",
  提款密码必须为数字: "প্রত্যাহারের পাসওয়ার্ড অবশ্যই নম্বর দেওয়া উচিত",
  注册成功: "সফলভাবে নিবন্ধন করুন",
  购物车: "শপিং কার্ট",
  账户: "অ্যাকাউন্ট",
  我的账户: "আমার অ্যাকাউন্ট",
  已经有一个账户: "ইতিমধ্যে একটি অ্যাকাউন্ট আছে",
  新地址: "নতুন ঠিকানা",
  编辑地址: "সম্পাদক ঠিকানা",
  保存: "সংরক্ষণ করুন",
  是否默认: "ডিফল্ট হবে কিনা",
  具体地址: "নির্দিষ্ট ঠিকানা",
  请输入具体地址: "নির্দিষ্ট ঠিকানা লিখুন দয়া করে",
  地区: "অঞ্চল",
  请输入地区: "দয়া করে অঞ্চলটি প্রবেশ করুন",
  城市: "শহর",
  请输入城市: "শহরে প্রবেশ করুন",
  省份: "প্রদেশ",
  请输入省份: "প্রদেশ প্রবেশ করুন",
  邮政编码: "ডাক কোড",
  请输入邮政编码: "ডাক কোড লিখুন দয়া করে",
  电话号码: "টেলিফোন নম্বর",
  请输入电话号码: "ফোন নম্বর লিখুন দয়া করে",
  收货人: "কনসনি",
  请输入收货人: "দয়া করে কনসাইনিতে প্রবেশ করুন",
  保存成功: "সফল হতে",
  最畅销的商家: "সেরা -বিক্রয় বণিক",
  查看所有的商家: "সমস্ত বণিক পরীক্ষা করুন",
  支持政策: "সমর্থন নীতি",
  您的电子邮件地址: "আপনার ইমেল ঠিকানা",
  订阅: "সাবস্ক্রিপশন",
  联系方式: "যোগাযোগের তথ্য",
  地址: "ঠিকানা",
  美国伊利诺伊州霍夫曼庄园: "হলফম্যান মনোর, ইলিনয়, মার্কিন যুক্তরাষ্ট্র",
  快速链接: "দ্রুত লিঙ্ক",
  商家政策: "বণিক নীতি",
  submit: "জমা দিন",
  提款银行卡: "এডিবিবি কার্ড",
  我的面板: "আমার প্যানেল",
  提示: "ইঙ্গিত",
  确定登出吗: "আপনি কি নিশ্চিত যে আপনি লগ ইন করেছেন?",
  确定: "নিশ্চিত",
  取消: "বাতিল",
  项目添加到您的购物车: "প্রকল্পটি আপনার শপিং কার্টে যুক্ত করা হয়েছে",
  经常一起购买: "ঘন ঘন কিনুন",
  返回购物: "শপিং রিটার্ন",
  进行结算: "চেকআউট এগিয়ে যান",
  帮助热线: "হটলাইন সাহায্য করুন",
  查看所有通知: "সমস্ত বিজ্ঞপ্তি পরীক্ষা করুন",
  请输入密码: "পাসওয়ার্ড লিখুন দয়া করে",
  前往充值: "রিচার্জে যান",
  购物车物品: "শপিং কার্ট",
  查看购物车: "শপিং কার্ট পরীক্ষা করুন",
  钱包余额: "মানিব্যাগ ভারসাম্য",
  充值钱包: "রিচার্জ ব্যাগ",
  钱包充值_线下_: "ওয়ালেট রিচার্জ (অফলাইন)",
  申请提款: "প্রত্যাহারের জন্য আবেদন করুন",
  钱包收支明细: "মানিব্যাগের আয় এবং ব্যয়ের বিশদ",
  批准: "অনুমোদন",
  提现历史记录: "নিয়োগ historical তিহাসিক রেকর্ড",
  类型: "প্রকার",
  信息: "তথ্য",
  付款方式: "অর্থ প্রদানের পদ্ধতি",
  请选择付款方式: "অর্থ প্রদানের পদ্ধতিটি নির্বাচন করুন",
  Bill_Type_RECHARGE_BACK: "পটভূমি রিচার্জ",
  Bill_Type_RECHARGE_ONLINE: "অনলাইন রিচার্জ",
  Bill_Type_RECHARGE_REGISTER: "নিবন্ধন করুন",
  Bill_Type_RECHARGE_JACKPOT: "রিচার্জ",
  Bill_Type_RECHARGE_PRESENT: "রিচার্জ পুরষ্কার",
  Bill_Type_RECHARGE_FROM_COMMISSION: "কমিশন স্থানান্তর",
  Bill_Type_RECHARGE_TG_COMMISSION: "রিচার্জ প্রচার কমিশন",
  Bill_Type_REGISTER_TG_COMMISSION: "নিবন্ধন ও প্রচার কমিশন",
  Bill_Type_WITHDRAW: "প্রত্যাহার",
  Bill_Type_WITHDRAW_REJECT: "প্রত্যাহার",
  Bill_Type_DEDUCT_HANDLE: "ম্যানুয়াল ছাড়",
  Bill_Type_DEDUCT_RECHARGE_MONEY: "রিচার্জ",
  Bill_Type_MINING_PROFIT: "খনির আয়",
  Bill_Type_MINING_PROFIT_COMMISSION: "খনির আয় প্রচার কমিশন",
  Bill_Type_VIP_UPGRADE: "আপগ্রেড ভিআইপি",
  Bill_Type_FINANCE_BUY: "সম্পদ পরিচালনা পণ্য ক্রয়",
  Bill_Type_FINANCE_CAPITAL_RETURN: "আর্থিক ভারসাম্য রিটার্ন",
  Bill_Type_FINANCE_FEE: "আর্থিক হ্যান্ডলিং ফি",
  Bill_Type_FINANCE_PROFIT: "আর্থিক আয়",
  Bill_Type_FINANCE_BUY_COMMISSION:
    "সম্পদ পরিচালনার পণ্যগুলির জন্য কমিশন কিনুন",
  Bill_Type_FINANCE_PROFIT_COMMISSION: "সম্পদ পরিচালন পণ্য আয় কমিশন",
  Bill_Type_WHEEL_DRAW: "বড় টার্নটেবল রাফল",
  Bill_Type_BUY: "পণ্য কিনুন",
  Bill_Type_PAY_SHOP: "ডেলিভারি ফি প্রদান",
  Bill_Type_BUY_COMMISSION: "পণ্য কমিশন কিনুন",
  Bill_Type_DEPOSIT: "আমানত প্রদান করুন",
  Bill_Type_STORE_BUY: "পণ্য কিনুন",
  Bill_Type_STORE_BUY_REFUND: "একটি ফেরত কিনুন",
  Bill_Type: "Debt ণ পরিবর্তনের ধরণ",
  Before_Money: "পূর্ববর্তী পরিমাণ",
  Deal_Money: "অ্যাকাউন্ট পরিবর্তন পরিমাণ",
  After_Money: "পরবর্তী পরিমাণ",
  Bill_Time: "অ্যাকাউন্ট পরিবর্তন সময়",
  No_More_Data: "আর কোনও ডেটা নেই",
  Apply_Money: "অ্যাপ্লিকেশন পরিমাণ",
  Apply_Time: "আবেদনের সময়",
  Withdraw_Info: "হ্যান্ডলিং ফি: {ফি}, অ্যাকাউন্টে: {অর্থ}",
  提款订单状态_CHECKING: "পর্যালোচনা করা",
  提款订单状态_TRANSFERRING: "স্থানান্তর",
  提款订单状态_PASS: "নিশ্চিত করুন",
  提款订单状态_REJECT: "প্রত্যাখ্যান",
  暂无可用充值方式: "কোনও দরকারী রিচার্জ পদ্ধতি নেই",
  钱包收款码: "ওয়ালেট সংগ্রহ কোড",
  钱包地址: "মানিব্যাগের ঠিকানা",
  金额限制: "পরিমাণ সীমা",
  复制: "অনুলিপি",
  付款凭证: "পেমেন্ট ভাউচার",
  收款银行: "গ্রহণযোগ্য ব্যাংক",
  收款人: "ক্যাশিয়ার",
  收款账号: "প্রাপ্তি অ্যাকাউন্ট",
  付款银行: "পে ব্যাংক",
  付款人: "প্রদানকারী",
  付款账号: "পেমেন্ট অ্যাকাউন্ট",
  请输入付款银行: "পেমেন্ট ব্যাংক প্রবেশ করান দয়া করে",
  请输入付款人: "প্রদানকারী প্রবেশ করান দয়া করে",
  请输入付款账号: "পেমেন্ট অ্যাকাউন্ট লিখুন দয়া করে",
  请上传付款凭证: "পেমেন্ট ভাউচার আপলোড করুন",
  充值金额: "রিচার্জ পরিমাণ",
  请输入充值金额: "রিচার্জের পরিমাণ লিখুন দয়া করে",
  submitting: "জমা দেওয়া ...",
  Confirm: "জমা দিন",
  Commit_Success: "সফল জমা",
  balanceType_BALANCE: "ভারসাম্য",
  balanceType_COMMISSION: "কমিশন",
  Balance: "অ্যাকাউন্ট ভারসাম্য",
  Wash_Money: "কোডিং",
  请选择银行账户: "ব্যাংক অ্যাকাউন্ট নির্বাচন করুন",
  卡号类型: "কার্ড নম্বর",
  提现金额: "প্রত্যাহারের পরিমাণ",
  提款金额: "প্রত্যাহারের পরিমাণ",
  不能为空: "খালি থাকতে পারে না",
  金额不正确: "ভুল পরিমাণ",
  please_input_withdraw_password: "প্রত্যাহারের পাসওয়ার্ড লিখুন দয়া করে",
  withdraw_password_format_error:
    "প্রত্যাহারের পাসওয়ার্ড অবশ্যই 4-16-বিট অক্ষর হতে হবে",
  Fee: "হ্যান্ডলিং ফি",
  实际到账: "আসলে",
  交易币种: "ট্রেডিং মুদ্রা",
  原始密码: "আদিম পাসওয়ার্ড",
  confirm_password_error: "দুটি ইনপুট মধ্যে পাসওয়ার্ড ভুল",
  save_success: "সফল হতে",
  please_input: "প্রবেশ করুন",
  old_password: "পুরানো পাসওয়ার্ড",
  new_password: "নতুন পাসওয়ার্ড",
  please_input_confirm_password: "দয়া করে আবার পাসওয়ার্ডটি নিশ্চিত করুন",
  没有找到符合条件的商品: "যোগ্য পণ্যগুলি খুঁজে পাচ্ছেন না",
  Search: "অনুসন্ধান",
  全部: "সব",
  EnumGoodsOrderState_USER_PAY: "বিতরণ করা",
  EnumGoodsOrderState_SHOP_PAY: "বিতরণ",
  EnumGoodsOrderState_SUCCESS: "সমাপ্তি",
  EnumGoodsOrderState_CANCEL: "বাতিল",
  EnumGoodsOrderState_REFUND_SUCCESS: "ফেরত",
  订单号: "অর্ডার নম্বর",
  用户名称: "ব্যবহারকারীর নাম",
  收益: "আয়",
  支付时间: "বেতন সময়",
  配送时间: "বিতরণ সময়",
  完成时间: "সম্পূর্ণ সময়",
  发货: "জাহাজ",
  全选: "সম্পূর্ণ নির্বাচন",
  物品已添加到愿望清单: "আইটেমগুলি ইচ্ছার তালিকায় যুক্ত করা হয়েছে",
  物品已添加到比较列表: "আইটেমগুলি তুলনা তালিকায় যুক্ত করা হয়েছে",
  购买成功提示: "অভিনন্দন, সফলভাবে কিনুন",
  订单列表: "অর্ডার তালিকা",
  商品名: "পণ্যের নাম",
  图片: "ছবি",
  没有品牌: "ব্র্যান্ড নেই",
  基本信息: "বেসিক তথ্য",
  Account_Name: "নাম",
  Bank_Account: "ব্যাংক অ্যাকাউন্ট",
  Bank_Phone: "মোবাইল ফোন নম্বর সংরক্ষণ করুন",
  IFSC: "আইএফএসসি অ্যাকাউন্ট",
  UPI: "ইউপিআই অ্যাকাউন্ট",
  PIX: "পিক্স অ্যাকাউন্ট নম্বর",
  CPF: "সিপিএফ অ্যাকাউন্ট",
  GCASH: "GCASH অ্যাকাউন্ট",
  POWWI: "পাওউই অ্যাকাউন্ট",
  身份证号: "আইডি নম্বর",
  Edit: "সংশোধন",
  Delete: "মুছুন",
  Add: "বৃদ্ধি",
  Forget_Withdraw_Password: "প্রত্যাহারের পাসওয়ার্ড দিয়ে ভুলে যান",
  Bank_Card_Info: "ব্যাংক কার্ডের তথ্য",
  收款人地址: "ক্যাশিয়ার ঠিকানা",
  SWIFT: "সুইফট",
  Bank_Branch: "সাব -ব্রাঞ্চের নাম",
  分行代码: "শাখা কোড",
  银行地址: "ব্যাংক ঠিকানা",
  Email: "ইমেল",
  银行卡长度必须超过:
    "ব্যাংক কার্ডের দৈর্ঘ্য অবশ্যই {দৈর্ঘ্য} ছাড়িয়ে যেতে হবে",
  银行卡格式不正确: "ব্যাংক কার্ডের ফর্ম্যাটটি ভুল",
  Do_you_confirm_delete: "আপনি কি মুছে ফেলুন?",
  Please_Login_First: "প্রথমে লগ ইন করুন",
  Bank_Name: "ব্যাংকের নাম",
  Please_add_bank_first:
    "আপনি কোনও ব্যাংক কার্ডকে বাইন্ড করেন নি, দয়া করে প্রথমে এটি যুক্ত করুন",
  withdrawType: "প্রত্যাহার",
  withdraw_money_limit:
    "প্রত্যাহারের পরিমাণ অবশ্যই 0 এর চেয়ে বেশি এবং {ব্যালেন্স of এর চেয়ে কম বা সমান হতে হবে",
  withdraw_times_limit:
    "আপনি আজ {লিমিটটাইমস} বার পরে {টুডে {বার, আপনি হ্যান্ডলিং ফিটির প্রত্যাহার} % চার্জ করবেন। এটি কি অর্থ প্রত্যাহার করতে দৃ determined ়প্রতিজ্ঞ?",
  Copy_Success: "প্রতিলিপি",
  商店首页: "হোমপেজ স্টোর",
  所有产品: "সমস্ত পণ্য",
  新到货产品: "নতুন -আরআইএল পণ্য",
  所有商家: "সমস্ত বণিক",
  请上传: "দয়া করে আপলোড করুন",
  请输入: "প্রবেশ করুন",
  忘记密码: "পাসওয়ার্ড ভুলে যান",
  记得我: "আমাকে মনে আছে",
  共_件: "মোট {0} টুকরা",
  取消订单: "অর্ডার বাতিল করুন",
  申请退款: "ফেরতের জন্য আবেদন করুন",
  未知商家: "অজানা বণিক",
  到账: "অ্যাকাউন্ট",
  提款订单状态: "একটি প্রত্যাহার আদেশের স্থিতি",
  前_名类别: "প্রথম {0 of এর বিভাগ",
  取消订单原因_不想要了: "আর চাই না",
  取消订单原因_商品错选_多选: "পণ্য ভুল/একাধিক পছন্দ",
  取消订单原因_商品无货: "আউট -গুডস",
  取消订单原因_地址信息填写错误: "ঠিকানা তথ্য ত্রুটি পূরণ করুন",
  取消订单原因_商品降价: "পণ্য মূল্য হ্রাস",
  取消订单原因_价格高于其他平台: "অন্যান্য প্ল্যাটফর্মের চেয়ে দাম বেশি",
  取消订单原因_没用_少用_错用优惠: "কিছুই/কম/ত্রুটি ছাড় ব্যবহার করুন",
  退款原因_拍错_多拍_不喜欢: "ভুলটি নিন/আরও অঙ্কুর করুন/এটি পছন্দ করবেন না",
  退款原因_商品成分描述不符: "পণ্য উপাদান বিবরণ মেলে না",
  退款原因_与商家协商一致退款: "বণিক ফেরতের সাথে পরামর্শ",
  退款原因_生产日期_保质期与商品描述不符:
    "উত্পাদনের তারিখ/শেল্ফ লাইফ পণ্যের বর্ণনার সাথে মেলে না",
  退款原因_图片_产地_批号_规格等描述不符:
    "চিত্র/উত্স/ব্যাচ নম্বর/স্পেসিফিকেশন ইত্যাদি স্থান",
  退款原因_质量问题: "মানের সমস্যা",
  退款原因_商品变质_发霉_有异物: "পণ্য লুণ্ঠন/ছাঁচ/বিদেশী শরীর",
  退款原因_少件_含缺少配件_: "ছোট আইটেম (আনুষাঙ্গিক অভাব সহ)",
  退款原因_收到商品时有破损_污渍_变形:
    "পণ্যটি গ্রহণ করার সময়, ক্ষতি/দাগ/বিকৃতি রয়েছে",
  退款原因_假冒品牌: "জাল",
  退款原因_发票问题: "চালানের সমস্যা",
  退款原因_商家发错货: "বণিকরা ভুল পণ্য প্রেরণ করে",
  退款原因_预约不到_商家不给退换:
    "কোনও অ্যাপয়েন্টমেন্ট করতে পারে না/বণিক ফেরত দেওয়া হবে না",
  退款失败: "ফেরত ব্যর্থতা",
  退款处理中: "ফেরত প্রক্রিয়াজাতকরণ",
  默认: "ডিফল্ট",
  产品查询: "পণ্য ক্যোয়ারী",
  商店LOGO: "শপ লোগো",
  推广码: "প্রচার কোড",
  查看所有: "সব পরীক্ষা করুন",
  确认收货成功: "নিশ্চিত করুন যে প্রাপ্তি সফল হয়েছে",
  物流公司: "লজিস্টিক সংস্থা",
  物流单号: "লজিস্টিক অর্ডার নম্বর",
  发货时间: "বিতরণ সময়",
  请先选择商品规格: "প্রথমে পণ্য স্পেসিফিকেশন নির্বাচন করুন",
  个人信息: "ব্যক্তিগত তথ্য",
  您的用户名: "আপনার ব্যবহারকারীর নাম",
  你的名字: "আপনার নাম",
  登录名: "ব্যবহারকারীর নাম",
  你的邮件: "আপনার মেইল",
  你的密码: "আপনার পাসওয়ার্ড",
  重复输入密码: "পাসওয়ার্ড পুনরাবৃত্তি",
  店铺名称: "শপ নাম",
  证书类型: "প্রকার",
  身份证: "আইডি কার্ড",
  护照: "পাসপোর্ট",
  驾驶执照: "ড্রাইভারের লাইসেন্স",
  社会保障卡: "সামাজিক সুরক্ষা কার্ড",
  证书正面: "ইতিবাচক শংসাপত্র",
  证书反面: "প্রমাণ",
  确认收货: "পণ্য প্রাপ্তি নিশ্চিত করুন",
  请选择取消订单的原因必选:
    "অর্ডার বাতিল করার কারণটি নির্বাচন করুন (প্রয়োজনীয়):",
  请选择申请退款的原因必选:
    "রিফান্ডের জন্য আবেদনের কারণ নির্বাচন করুন (প্রয়োজনীয়):",
  留言: "বার্তা",
  请输入留言: "দয়া করে একটি বার্তা লিখুন",
  没有帐户: "কোন অ্যাকাউন্ট",
  钱包充值: "ওয়ালেট রিচার্জ",
  输入您的文字: "আপনার পাঠ্য লিখুন",
  商家登录: "বণিক লগইন",
  有关此产品的任何查询: "এই পণ্য উপর কোন প্রশ্ন",
  产品名称: "পণ্যের নাম",
  你的问题: "আপনার সমস্যা",
  白银店铺: "সিলভার শপ",
  铂金店铺: "প্ল্যাটিনাম শপ",
  钻石店铺: "হীরার দোকান",
  照片: "ছবি",
  已退货: "ফিরে",
  邮寄状态: "মেল স্থিতি",
  订单摘要: "অর্ডার অ্যাবস্ট্রাক্ট",
  收件地址: "আয়ের ঠিকানা",
  订购日期: "অর্ডার তারিখ",
  订单状态: "অর্ডার স্থিতি",
  总订单金额: "মোট অর্ডার পরিমাণ",
  邮寄方式: "মেইলিং পদ্ধতি",
  附加信息: "অতিরিক্ত তথ্য",
  订单详细信息: "বিস্তারিত তথ্য",
  交货类型: "বিতরণ প্রকার",
  进行评论: "মন্তব্য",
  已评论: "মন্তব্য",
  订单金额: "অর্ডার পরিমাণ",
  优惠券: "কুপন",
  统一运费: "ইউনিফাইড ফ্রেইট",
  送货地址: "শিপিং ঠিকানা",
  评分: "স্কোর",
  你的意见: "আপনার মতামত",
  匿名: "বেনামে",
  现金: "নগদ",
  详情: "বিশদ",
  收货地址: "প্রাপ্তি ঠিকানা",
  暂时没有对话: "আপাতত কোনও কথোপকথন নেই",
  你: "তুমি",
  输入您的回复: "আপনার উত্তর লিখুন",
  删除成功: "মুছুন",
  品牌: "ব্র্যান্ড",
  已缴纳的保证金: "প্রদত্ত মার্জিন",
  黄金店铺: "গোল্ডেন শপ",
  没有更多数据: "আর কোনও ডেটা নেই",
  站内信: "অন ​​-সাইট লেটার",
  系统通知: "সিস্টেম বিজ্ঞপ্তি",
  邮箱: "মেল",
  手机号: "ফোন নম্বর",
  你的手机号: "আপনার মোবাইল ফোন নম্বর",
  营业执照: "ব্যবসায় লাইসেন্স",
  你的邮箱: "আপনার মেলবক্স",
  搜索结果: "অনুসন্ধান ফলাফল",
  系统公告: "সিস্টেম ঘোষণা",
  客服: "গ্রাহক পরিষেবা",
  消息已撤回: "খবরটি প্রত্যাহার করা হয়েছে",
  物流详情: "লজিস্টিক বিশদ",
  充值: "শীর্ষে",
  提现: "প্রত্যাহার",
  信用分: "ক্রেডিট",
  余额: "ভারসাম্য",
  佣金: "কমিশন",
  继续购物: "কেনাকাটা চালিয়ে যান",
  订单结算: "অর্ডার নিষ্পত্তি",
  加入对比: "তুলনা যোগ করুন",
  佣金余额: "কমিশন ভারসাম্য",
  刷新: "রিফ্রেশ",
  刷新成功: "রিফ্রেশ",
  官网: "অফিসিয়াল ওয়েবসাইট",
  税号: "কর নম্বর",
  订单: "অর্ডার",
  合计: "মোট",
  系统安全: "সিস্টেম সুরক্ষা",
  Recharge_Money_Limit:
    "রিচার্জের পরিমাণ অবশ্যই {মিনিট} এবং {সর্বোচ্চ} এর মধ্যে থাকতে হবে",
  限时优惠: "সীমিত সময়",
  高价回收: "উচ্চ -মূল্যের পুনর্ব্যবহারযোগ্য",
  姓名: "নাম",
  商品订单号: "পণ্য আদেশ নম্বর",
  商品在线回收: "পণ্য অনলাইন পুনর্ব্যবহারযোগ্য",
  提交: "জমা দিন",
  回收记录: "পুনরুদ্ধার রেকর্ড",
  回收状态: "পুনরুদ্ধারের স্থিতি",
  回收价格: "পুনর্ব্যবহারযোগ্য মূল্য",
  纳税码: "ট্যাক্স কোড",
  买家登录: "লগ ইন",
  买家注册: "নিবন্ধন করুন",
  language: "চাইনিজ",
  助力提示:
    "বণিকদের সহায়তা করা তাদের স্টোরগুলিতে প্ল্যাটফর্মের এক্সপোজারকে বাড়িয়ে তুলতে পারে এবং দিনের সংখ্যা তত বেশি, এক্সপোজার তত বেশি।",
  已累计助力: "Cumulatively সহায়তা",
  今日已助力: "আজ সাহায্য করেছে",
  立即助力: "অবিলম্বে সাহায্য করুন",
  商家助力: "বণিক সহায়তা",
  证件号码: "আইডি নম্বর",
  证书号码: "শংসাপত্র নম্বর",
  男鞋: "পুরুষদের জুতা",
  游戏玩具: "খেলনা খেলনা",
  使用条款: "ব্যবহারের শর্তাদি",
  商家: "বণিক",
  已助力: "সাহায্য করেছে",
  被助力: "সাহায্য করা হচ্ছে",
  用户: "ব্যবহারকারী",
  助力记录: "সাহায্য রেকর্ড",
  消息类型: "বার্তা প্রকার",
  消息内容: "বার্তা সামগ্রী",
  链接: "লিঙ্ক",
  文本: "পাঠ্য",
  清空: "পরিষ্কার",
  评论成功: "মন্তব্য সফল",
  扫描二维码: "QR কোড স্ক্যান করুন",
  转入: "স্থানান্তর",
  收款: "সংগ্রহ",
  任务下单中心: "টাস্ক অর্ডার কেন্দ্র",
  记录: "রেকর্ড",
  任务倒计时: "টাস্ক কাউন্টডাউন",
  倒计时后自动放弃: "কাউন্টডাউনের পরে স্বয়ংক্রিয়ভাবে ছেড়ে দিন",
  业务码: "ব্যবসার কোড",
  选择商品分类: "পণ্য বিভাগ নির্বাচন করুন",
  可多选: "একাধিক নির্বাচন সম্ভব",
  加载分类中: "বিভাগগুলি লোড হচ্ছে",
  暂无分类: "এখনও কোন শ্রেণীবিভাগ",
  产品类别: "পণ্য বিভাগ",
  账户余额: "অ্যাকাউন্ট ব্যালেন্স",
  立即结算: "অবিলম্বে নিষ্পত্তি",
  任务已自动放弃: "কাজটি স্বয়ংক্রিয়ভাবে পরিত্যাগ করা হয়েছে",
  商品分类: "পণ্য শ্রেণীবিভাগ",
  订单详情: "অর্ডার বিশদ",
  预计收益: "আনুমানিক আয়",
  预计佣金收益: "আনুমানিক কমিশন আয়",
  收益率: "ফলন",
  扣款账户: "ডেবিট অ্যাকাউন্ট",
  确认结算: "নিষ্পত্তি নিশ্চিত করুন",
  未选择: "নির্বাচিত হয়নি",
  请选择商品分类: "একটি পণ্য বিভাগ নির্বাচন করুন",
  下单成功: "অর্ডার সফলভাবে স্থাপন করা হয়েছে",
  下单失败: "অর্ডার ব্যর্থ হয়েছে",
  请重试: "আবার চেষ্টা করুন",
  订单记录: "অর্ডার রেকর্ড",
  没有更多了: "আর না",
  业务号: "ব্যবসার নম্বর",
  商品类型: "পণ্যের ধরন",
  佣金收益: "কমিশন আয়",
  待结算: "মুলতুবি নিষ্পত্তি",
  已结算: "নিষ্পত্তি হয়েছে",
  已取消: "বাতিল",
  加载失败: "লোডিং ব্যর্থ হয়েছে৷",
  倒计时: "কাউন্টডাউন",
  随机商品: "এলোমেলো আইটেম",
  为: "জন্য",
  商户助力可提升商品曝光度: "বণিক সহায়তা পণ্যের এক্সপোজার বাড়াতে পারে",
  累计助力越高推荐权重越高: "সঞ্চিত সহায়তা যত বেশি, সুপারিশের ওজন তত বেশি।",
  实时助力动态: "রিয়েল-টাইম সহায়তা গতিবিদ্যা",
  助力奖励: "পুরষ্কার বুস্ট করুন",
  随机奖励金额已生成: "র‍্যান্ডম পুরস্কারের পরিমাণ জেনারেট করা হয়েছে",
  开心收下: "এটা মেনে নিয়ে খুশি",
  助力已结束: "সাহায্য শেষ হয়েছে",
  助力成功: "সাফল্য সাহায্য করুন",
  成功: "সাফল্য",
  进行中: "চলছে",
  等待: "অপেক্ষা করুন",
  助力失败: "সাহায্য ব্যর্থ হয়েছে",
  任務: "কাজ",
  下单失败_请稍后重试: "অর্ডার ব্যর্থ হয়েছে, পরে আবার চেষ্টা করুন",
  任务: "টাস্ক"
};
